import { Navigate, Outlet } from "react-router-dom";
import { hasValidAuthSession } from "../helpers/authSession";
import Constant from "../util/constant";

const ProtectedOrganiserRoute = () => {
  const role = window.localStorage.getItem("role");
  const allowed =
    hasValidAuthSession() && role === Constant.ROLES.ORGANISER;

  return allowed ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedOrganiserRoute;
